import { Navigate, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import logger from "../utils/logger";


const ProtectedRoute = ({ children }) => {
  //   const { authStatus } = useContext(AuthContext)

  const authStatus = useSelector(
    (state) => state.enableRoute.status
  )

  const location = useLocation();

  logger.debug('location ProtectedRoute: ', location)

  // const authStatus = 'authorized'

  logger.debug('authstatus es: ', authStatus)

const {isLogoutContext } = useSelector(state => state.routing)

logger.debug('isLogoutContext: ', isLogoutContext)
  

  return authStatus === "authorized" ?
    children :

    //? Sino esta autorizado navega al Login pero setea la ruta la que queria ir
    <Navigate
      to="/login"
      replace
      state={{ from: isLogoutContext ? '/' : location.pathname }}
    />
}

export default ProtectedRoute